import { useEffect, useState } from "react";
import api from "../../api/axios";
import { reportClientError } from "../../api/errorReporter";

import "../../css/layout.css";
import "../../css/card.css";
import "../../css/button.css";

import InfoCard from "../../components/InfoCard";
import HoldingCard from "../../components/HoldingCard";
import AppLayout from "../../layouts/AppLayout";
import Card from "../../components/Card";

function Dashboard() {

    const [dashboard, setDashboard] = useState({
        publicIp: "",
        deposit: {
            hundredPercentOrderAmountLong: 0
        },
        realizedProfitResponse: {
            totSellAmt: 0,
            rlztPlLong: 0
        },
        balance: {
            totalEvaluationAmountValue: 0,
            totalProfitValue: 0,
            totalProfitRateValue: 0,
            holdings: []
        },
        setting: {
            autoEnabled: true
        }
    });

    const [errorChk, setErrorChk] = useState(false);

    const load = () => {
    api.get("/auto/overview")
        .then(res => {

            if (!res?.data?.dashboard || typeof res.data.dashboard !== "object") {
                console.warn("Dashboard 데이터가 없습니다.", res);
                setErrorChk(true);
                return;
            }

            console.log(res.data);
            setDashboard(res.data.dashboard);
            setErrorChk(false);
        })
        .catch(err => {
            console.error(err);
            reportClientError(err, "API_ERROR", { endpoint: "/dashboard" });
        });
};

    useEffect(() => {
        load();

        console.log("자동배포 확인용 20260723")


        const timer = setInterval(load, 30000);

        return () => clearInterval(timer);

    }, []);

    /**
     * 안전한 숫자 변환
     */
    const safeNumber = (value) => {
        const num = Number(value);
        return Number.isFinite(num) ? num : 0;
    };

    /**
     * +, -, 천단위 콤마
     */
    const formatSignedNumber = (value, isPercent = false) => {

        const num = safeNumber(value);

        const sign =
            num > 0
                ? "+"
                : num < 0
                    ? "-"
                    : "";

        return sign + Math.abs(num).toLocaleString(undefined, {
            minimumFractionDigits: isPercent ? 2 : 0,
            maximumFractionDigits: isPercent ? 2 : 0
        });
    };

    const getProfitColor = (value) => {

        const num = safeNumber(value);

        if (num > 0) return "#d32f2f";
        if (num < 0) return "#1565c0";

        return "#000000";
    };

    const getProfitStyle = (profit) => ({
        marginTop: 15,
        fontWeight: "bold",
        color: getProfitColor(profit)
    });

    /**
     * 연간 수익률
     */
    const realized = dashboard.realizedProfitResponse ?? {};

    const totalSell = safeNumber(realized.totSellAmt);
    const realizedProfit = safeNumber(realized.rlztPlLong);

    const yearlyProfitRate =
        totalSell > 0
            ? (realizedProfit / totalSell) * 100
            : 0;

    return (

        <AppLayout
            title="GooseDuck Trading"
            subTitle={`자동매매 Dashboard (${dashboard.publicIp || "접속중..."}) ${errorChk?"오류":""}`}
        >

            <Card>
                <div>{`자동매매 : ${dashboard.setting?.autoEnabled ? "ON 🟢" : "OFF 🔴"}`}</div>
            </Card>

            <InfoCard
                title={`${new Date().getFullYear()} 연간 수익률`}
                valueStyle={getProfitStyle(yearlyProfitRate)}
                value={`${formatSignedNumber(yearlyProfitRate, true)} %`}
            />

            <InfoCard
                title={`${new Date().getFullYear()} 연간 평가손익`}
                valueStyle={getProfitStyle(realizedProfit)}
                value={`${formatSignedNumber(realizedProfit)} 원`}
            />

            <InfoCard
                title="예수금"
                value={`${safeNumber(
                    dashboard.deposit?.hundredPercentOrderAmountLong
                ).toLocaleString()} 원`}
            />

            <InfoCard
                title="현재 평가금액"
                value={`${safeNumber(
                    dashboard.balance?.totalEvaluationAmountValue
                ).toLocaleString()} 원`}
            />

            <InfoCard
                title="현재 평가손익"
                valueStyle={getProfitStyle(
                    dashboard.balance?.totalProfitValue
                )}
                value={`${formatSignedNumber(
                    dashboard.balance?.totalProfitValue
                )} 원`}
            />

            <InfoCard
                title="현재 수익률"
                valueStyle={getProfitStyle(
                    dashboard.balance?.totalProfitRateValue
                )}
                value={`${formatSignedNumber(
                    dashboard.balance?.totalProfitRateValue,
                    true
                )} %`}
            />

            {
                dashboard.balance?.holdings?.length === 0
                    ? (
                        <InfoCard
                            title="보유 종목"
                            value="없음"
                        />
                    )
                    : (
                        dashboard.balance.holdings.map(holding => (
                            <HoldingCard
                                key={holding.stockCode}
                                holding={holding}
                            />
                        ))
                    )
            }

        </AppLayout>

    );
}

export default Dashboard;
